import React, { useState } from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

const Datepicker3 = ({ startDate, endDate, setStartDate, setEndDate }) => {
    
  const onRangeChange = (dates, dateStrings) => {
    if (dates) {
      // Step 3: Update state when date range changes
      setStartDate(dateStrings[0]);
      setEndDate(dateStrings[1]);

      console.log("From: ", dates[0], ", to: ", dates[1]);
      console.log("From: ", dateStrings[0], ", to: ", dateStrings[1]);
    } else {
      // Clear the dates if the range is cleared
      setStartDate(null);
      setEndDate(null);
      console.log("Clear");
    }
  };

  const rangePresets = [
    { label: "Today", value: [dayjs(), dayjs()] },
    { label: "Yesterday", value: [dayjs().subtract(1, "day"), dayjs()] },
    { label: "Last Week", value: [dayjs().subtract(6, "day"), dayjs()] }, // Changed to ensure exactly 7 days
    { label: "Last Month", value: [dayjs().subtract(29, "day"), dayjs()] }, // Changed to ensure exactly 30 days
    { label: "Last Quarter", value: [dayjs().subtract(89, "day"), dayjs()] }, // Changed to ensure exactly 90 days
];
  const disableFutureDates = (current) => {
    return current && current > dayjs().endOf("day");
  };

  return (
    <div className="range-picker-container">
      <RangePicker
        presets={rangePresets}
        onChange={onRangeChange}
        disabledDate={disableFutureDates}
        // mode={["day", "day"]} // Restricts view to the current month
      />
      {/* Display selected dates */}
    </div>
  );
};

export default Datepicker3;